import { ClienteTaxa } from '../../../../../../../types/cliente-taxa';

export type TaxaFieldErrors = Partial<Record<keyof ClienteTaxa, string>>;

const PERCENT_FIELDS: Array<keyof ClienteTaxa> = [
  'taxaInternacional',
  'reservaGlobal',
  'taxaExtraInternacional',
  'taxaNacional',
  'taxaPix',
  'reservaNacional',
  'taxaExtraNacional',
  'taxaSaque',
];

const TIME_FIELDS: Array<keyof ClienteTaxa> = [
  'tempoRecebimento',
  'tempoReservaGlobal',
  'tempoReservaNacional',
];

const validatePercent = (value: unknown): string | null => {
  if (value === '' || value == null) return 'Obrigatório';
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return 'Valor inválido';
  if (n < 0) return 'Não pode ser negativo';
  if (n > 100) return 'Máximo 100%';
  return null;
};

const validateTime = (value: unknown): string | null => {
  if (value === '' || value == null) return 'Obrigatório';
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return 'Valor inválido';
  if (!Number.isInteger(n)) return 'Deve ser inteiro';
  if (n < 0) return 'Não pode ser negativo';
  return null;
};

export const validateTaxa = (
  values: Partial<Record<keyof ClienteTaxa, unknown>>,
): TaxaFieldErrors => {
  const errors: TaxaFieldErrors = {};
  for (const f of PERCENT_FIELDS) {
    const e = validatePercent(values[f]);
    if (e) errors[f] = e;
  }
  for (const f of TIME_FIELDS) {
    const e = validateTime(values[f]);
    if (e) errors[f] = e;
  }
  return errors;
};

export const hasErrors = (errors: TaxaFieldErrors): boolean =>
  Object.keys(errors).length > 0;
